'use strict';

function CnSummaryFormController($modal, $q) {
  var vm = this;
  var modal = $modal({ template: require('./cn-summary-form.modal.html'), show: false });

  vm.$onInit = $onInit;
  vm.showModal = showModal;
  vm.submit = _submit;
  vm.lock = _unlock;

  function $onInit() {
    vm.isComplete = vm.isComplete === true || false;
    vm.isLockable = vm.isLockable === true || false;
    vm.noModal = vm.noModal === true || false;
    vm.onLock = vm.onLock() || $q.resolve;
    vm.showPrint = vm.showPrint === true || false;
  }

  function showModal() {
    modal.$scope.title = vm.modalTitle;
    modal.$scope.body = vm.modalBody;
    modal.$scope.buttonClass = vm.modalButtonClass;
    modal.$scope.modalClass = vm.modalClass;
    modal.$scope.confirmText = vm.modalButtonConfirmText;
    modal.$scope.denyText = vm.modalButtonDenyText;
    modal.$scope.submit = _submit;
    modal.unlock = _unlock;
    modal.show();
  }

  function _submit() {
    modal.$scope.lock = true;

    return vm.onLock()
      .then(modal.unlock)
      .finally(modal.hide);
  }

  function _unlock() {
    modal.$scope.lock = false;
  }
}

module.exports = CnSummaryFormController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-summary-form/cn-summary-form.controller.js
 ** module id = 103
 ** module chunks = 0
 **/